import fetch from "@lib/fetch";

import { buildFetchRequestArgs } from "../formData";
import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdAgentPreview } from "./constants";
import type {
  PostwsGenerativeAiAppGroupIdAgentPreviewPayload,
  PostwsGenerativeAiAppGroupIdAgentPreviewProps,
} from "./types";
import { isAgentPreviewAsyncResult } from "./validators";

export const postwsGenerativeAiAppGroupIdAgentPreview = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdAgentPreview,
  async (
    signal,
    {
      appGroupId,
      agentDefinition,
      testPrompt,
      userId,
      randomUser,
      customUserHash,
      triggerPropertiesHash,
      campaignId,
      canvasId,
      scope,
      stepId,
      briefFile,
      jobToken,
      mockResponseLength,
    }: PostwsGenerativeAiAppGroupIdAgentPreviewProps
  ): Promise<{}> => {
    const payload: PostwsGenerativeAiAppGroupIdAgentPreviewPayload = {
      job_token: jobToken,
      agent_definition: agentDefinition,
      test_prompt: testPrompt,
      user_id: userId,
      random_user: randomUser,
      custom_user_hash: customUserHash,
      trigger_properties_hash: triggerPropertiesHash,
      campaign_id: campaignId,
      canvas_id: canvasId,
      scope: scope,
      step_id: stepId,
      mock_response_length: mockResponseLength,
    };
    const { params, options, setContentType } = buildFetchRequestArgs(payload, briefFile);

    return await fetch(
      `/${appGroupId}/generative_ai/agent/preview`,
      "POST",
      params,
      { signal, ...options },
      {
        setContentType,
        propagateFetchRequestError: false,
      }
    );
  },
  isAgentPreviewAsyncResult
);
